export default __webpack_public_path__ + "static/media/vuesax-linear-bag-happy.f69a1bc3.svg";